import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-bg-primary border-t border-border-primary pt-24 pb-12 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-brand-teal/5 blur-[120px] rounded-full pointer-events-none -mb-64 -mr-32" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-24">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="text-2xl tracking-tight font-extrabold hover:text-brand-teal transition-colors relative group inline-block">
              <span className="relative z-10 text-text-primary">RICH<span className="text-brand-teal-light font-light">GURU</span></span>
              <div className="absolute inset-0 bg-brand-teal/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </Link>
            <p className="text-text-secondary text-sm leading-relaxed max-w-xs font-light">
              Sovereign wealth management powered by neural intelligence. Engineered for those who command the markets.
            </p>
            <div className="flex space-x-4">
              {['Twitter', 'Discord', 'Github', 'Telegram'].map((social) => (
                <a key={social} href="#" className="w-8 h-8 rounded-full border border-border-primary flex items-center justify-center text-text-tertiary hover:text-brand-teal hover:border-brand-teal transition-all">
                  <span className="sr-only">{social}</span>
                  <div className="w-1 h-1 rounded-full bg-current" />
                </a>
              ))}
            </div>
          </div>

          {/* Protocol Links */}
          <div>
            <h4 className="text-[10px] font-black uppercase tracking-[0.2em] text-text-primary mb-8">Protocol</h4>
            <ul className="space-y-4">
              {[
                { label: 'Neural Terminal', path: '/dashboard' },
                { label: 'Market Matrix', path: '/market-watch' },
                { label: 'Execution Layer', path: '/trading' },
                { label: 'Asset Ledger', path: '/portfolio' }
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-sm font-medium text-text-secondary hover:text-brand-teal transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Intelligence Links */}
          <div>
            <h4 className="text-[10px] font-black uppercase tracking-[0.2em] text-text-primary mb-8">Intelligence</h4>
            <ul className="space-y-4">
              {[
                { label: 'Neural Scan', path: '/image-analysis' },
                { label: 'Pattern Matrix', path: '/advanced-analysis' },
                { label: 'Heuristics', path: '/advanced-indicators' },
                { label: 'Neural Assistant', path: '/assistant' }
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-sm font-medium text-text-secondary hover:text-brand-teal transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Infrastructure Links */}
          <div>
            <h4 className="text-[10px] font-black uppercase tracking-[0.2em] text-text-primary mb-8">Infrastructure</h4>
            <ul className="space-y-4">
              {[
                { label: 'Security Layer', path: '/glass-demo' },
                { label: 'API Protocol', path: '/api-test' },
                { label: 'Terms of Access', path: '#' },
                { label: 'Privacy Cryptography', path: '#' }
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-sm font-medium text-text-secondary hover:text-brand-teal transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border-primary flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-[10px] font-black uppercase tracking-[0.2em] text-text-tertiary">
            © 2026 RICHGURU PROTOCOL. ALL RIGHTS RESERVED.
          </div>
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-brand-teal animate-pulse" />
              <span className="text-[10px] font-black uppercase tracking-[0.2em] text-brand-teal-light">Network Status: Nominal</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
